import { ChangeEvent } from 'react';
import { observer } from 'mobx-react-lite';

import { JobAvailabilityType } from 'us-web-services';
import { useDependencies } from '../../../dependencies';

interface Props {
  subtext?: string;
  text: string;
  type: JobAvailabilityType;
}

export const JobAvailabilityItem = observer(({ subtext, text, type }: Props) => {
  const {
    services: { tracker },
    stores: { sitter },
  } = useDependencies();

  const handleCheckboxChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const trackingProps = {
      elementChecked: e.currentTarget.checked,
      elementId: e.currentTarget.id,
      elementName: e.currentTarget.name,
      elementText: e.currentTarget.innerText,
    };

    tracker.track('clicked-button', trackingProps);

    sitter.availabilityToggle(type, e.target.checked);
  };
  const isSelected = (): boolean => sitter.availabilityIsSelected(type);

  return (
    <label
      className={`${isSelected() ? 'bg-sapphire' : 'bg-neutral-200'
        } relative block lg:inline-block rounded-full max-w-xs px-3 se:px-4 py-2 mb-3 cursor-pointer select-none transition-all`}
    >
      <input
        type='checkbox'
        className='reverse peer rounded-sm align-middle border-2 border-almostBlack checked:border-white bg-neutral-200 checked:text-white focus:ring-0 focus:ring-offset-0 focus:outline-none'
        checked={isSelected()}
        name={type.replace(' ', '')}
        onChange={handleCheckboxChange}
      />
      <span className='ml-3 mt-0.5 align-middle inline-block font-semibold lg:text-sm text-almostBlack peer-checked:text-white'>
        {text}
        {subtext && (
          <span className='text-sm lg:absolute lg:top-11 lg:text-almostBlack lg:font-normal lg:text-xs lg:left-0 lg:right-0 lg:text-center'>
            {' '}
            {subtext}
          </span>
        )}
      </span>
    </label>
  );
});
